import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { login, resetPassword, clearResult, clearLoginResult, validateToken, requestPwEmail } from '../action/userActions'
import '../../css/ewLogin.css'
import { Button, Form, Card, Col, Modal, Row, Alert } from 'react-bootstrap'


class ResetPassword extends Component {
    constructor(props) {
        super(props)
        let hasSpecialChars = { valid: false, desc: 'Has 1 Special Character' }
        let hasNum = { valid: false, desc: 'Has 1 Number' }
        let hasUpperCase = { valid: false, desc: 'Has 1 Uppercase Letter' }
        let has10Chars = { valid: false, desc: 'Has At least 10 Characters' }

        let rules = [hasUpperCase, hasNum, hasSpecialChars, has10Chars]

        this.state = { userName: '', password: '', rules, isNewPassValid: false, isConfirmValid: false }
    }

    isValid(str) {
        return new Promise(res => {
            let hasSpecialChars = { valid: /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(str), desc: 'Has 1 Special Character' }
            let hasNum = { valid: /[0-9]/.test(str), desc: 'Has 1 Number' }
            let hasUpperCase = { valid: /[A-Z]/.test(str), desc: 'Has 1 Uppercase Letter' }
            let has10Chars = { valid: str && str.length >= 10, desc: 'Has At least 10 Characters' }

            let rules = [hasUpperCase, hasNum, hasSpecialChars, has10Chars]

            let isNewPassValid = has10Chars.valid && hasNum.valid && hasSpecialChars.valid && hasUpperCase.valid

            this.setState({ rules, newPassword: str, isNewPassValid }, () => res())

        })

    }

    render() {
        return <Form name="myform" hidden={this.props.loading} style={{ margin: '10px' }} onSubmit={(e) => {
            e.preventDefault()
            e.stopPropagation()
            console.log('user', this.props.user.success)
            if (!this.props.user.success) {
                this.props.dispatch(login({ userName: this.state.userName, password: this.state.password }))
            } else {
                let input = { userName: this.props.user.userName, password: this.state.newPassword }
                console.log('resetting pw', input)

                this.props.dispatch(resetPassword(input))
            }
        }}>
            <h3>
                Change Password
</h3>


            <Form.Row >
                <Form.Group as={Col} controlId="formGridEmail">
                    <Form.Label></Form.Label>
                    <Form.Control
					
					name='login'
                        className='login'
						disabled={this.props.user.success}
                        required={!this.props.user.success}
                        ref={email => this.email = email}
                        defaultValue={this.props.user.userName}
                        onChange={((e) => { this.setState({ userName: e.target.value }, () => {
							if(!this.props.user.success){
								this.email.focus() 
							}
							
							
							}) })} type="email" placeholder="Enter email" />
                </Form.Group>

            </Form.Row>

            <Form.Row hidden={this.props.user.success}>

                <Form.Group as={Col} controlId="formGridPassword">
                    <Form.Label></Form.Label>
                    <Form.Control
                        className='login'
                        required={!this.props.user.success}
                        ref={pw => this.pw = pw} defaultValue={this.state.password} onChange={((e) => { this.setState({ password: e.target.value }, () => this.pw.focus()) })} type="password" placeholder="Password" />
                </Form.Group>

            </Form.Row>
            <Col>
            </Col>
            <Col>
            <Row hidden={!this.props.user.success} className='pwRules'>
                <ul>
                    {this.state.rules.map(rule => {
                        return (
                            <li style={{ color: rule.valid ? 'black' : 'red' }} >
                                {rule.desc}
                            </li>
                        )
                    })}
                </ul>
            </Row>

            </Col>
            <Col></Col>
        
            <Form.Row hidden={!this.props.user.success}>

                <Form.Group as={Col} controlId="formGridNewPassword">
                    <Form.Label>New Password</Form.Label>
                    <Form.Control defaultValue={this.state.newPassword} ref={newPw => this.newPw = newPw} required={this.props.user.success} isInvalid={!this.state.isNewPassValid} isValid={this.state.isNewPassValid} onChange={((e) => {
                        this.isValid(e.target.value).then(() => this.newPw.focus())
                    })} type="password" placeholder="New Password" />
                </Form.Group>


                <Form.Group as={Col} controlId="formGridNewPasswordConfirm">
                    <Form.Label>Confirm New Password</Form.Label>
                    <Form.Control

                        defaultValue={this.state.newPasswordConfirm} ref={newConfrm => this.newConfirm = newConfrm} required={this.props.user.success} isInvalid={!this.state.isConfirmValid} isValid={this.state.isConfirmValid} onChange={((e) => {
                            const isConfirmValid = this.state.newPassword === e.target.value
                            this.setState({ newPasswordConfirm: e.target.value, isConfirmValid }, () => this.newConfirm.focus())
                        })} type="password" placeholder="Confirm New Password" />
                </Form.Group>

            </Form.Row>

            <Button type='submit' hidden={this.props.user.success} className='loginBtn' >
                Continue
                </Button>
            <Button className='loginBtn' style={{ backgroundColor: '#015daa' }} type='submit' disabled={!this.state.isNewPassValid || !this.state.isConfirmValid} hidden={!this.props.user.success}>
                Change Password
                </Button>
        </Form>
    }
}

const mapStateToProps = state => ({
    user: state.acct.user.loggedInUser,
    loading: state.acct.user.loading,
    pwReslt: state.acct.user.resetPasswordResult,
    pwError: state.acct.user.resetPwError
})

export default withRouter(connect(mapStateToProps)(ResetPassword))